'use client';

import { useMemo, useState } from 'react';
import { Price, Button, Drawer, Heading } from '@petsmart-ui/sparky';
import type { ProductHitPrice } from '@libs/algolia';

import AfterPay from '@app/pdp/components/Afterpay';
import { useProductDetails } from '@app/pdp/hooks/useProductDetails';
import { useProductPriceMapper } from './hooks';
import './ProductPrice.scss';

export default function ProductPrice() {
    const { product, selectedProduct } = useProductDetails();
    const selectedPrice = selectedProduct.price as ProductHitPrice;
    const pricePolicy = product.productPricePolicy;

    const { isStrikethrough, ...priceProps } =
        useProductPriceMapper(selectedPrice);
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);

    const showproductPricePolicy = useMemo(
        () =>
            !!pricePolicy?.pricePolicyTitle &&
            !!pricePolicy?.pricePolicyContent &&
            isStrikethrough,
        [
            isStrikethrough,
            pricePolicy?.pricePolicyContent,
            pricePolicy?.pricePolicyTitle,
        ]
    );

    if (!selectedPrice) {
        return null;
    }

    const openDrawer = () => {
        setIsDrawerOpen(true);
    };

    const closeDrawer = () => {
        setIsDrawerOpen(false);
    };

    return (
        <>
            <div className="product-price">
                <Price
                    className="product-price-sparky"
                    size="xl"
                    data-testid="product-price"
                    {...priceProps}
                />

                {showproductPricePolicy && (
                    <>
                        <Button
                            className="product-price-strikethrough-button"
                            iconName="info-outline"
                            iconPosition="before"
                            iconSize="md"
                            onClick={openDrawer}
                            text="Open strike-through price policy"
                            variant="bare"
                            hideText
                            circle
                            data-testid="product-price-strikethrough-button"
                        />
                        <Drawer
                            isActive={isDrawerOpen}
                            onClose={closeDrawer}
                            align="right"
                            ariaLabelledBy="drawer-heading"
                            className="product-price-strikethrough-drawer"
                            data-testid="product-price-strikethrough-drawer"
                        >
                            <Drawer.Header className="product-price-strikethrough-drawer-header">
                                <Heading
                                    id="drawer-heading"
                                    tagName="h2"
                                    size="headline"
                                >
                                    {pricePolicy?.pricePolicyTitle}
                                </Heading>
                            </Drawer.Header>
                            <Drawer.Body>
                                {pricePolicy?.pricePolicyContent}
                            </Drawer.Body>
                        </Drawer>
                    </>
                )}
            </div>
            <AfterPay />
        </>
    );
}
